module.exports = __webpack_public_path__ + "static/media/home.00833b62.mp4";